import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart2, Coins, CreditCard, Target, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from "../../ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "../../ui/card";
import AnimatedBackground from '../../utils/AnimatedBackground';
import TopBar from '../../utils/TopBar';
import Footer from '../../utils/Footer';

const Home: React.FC = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  }

  const items = [
    {
      title: "Dashboard",
      description: "View your financial overview",
      icon: BarChart2,
      color: "blue",
      link: "/dashboard"
    },
    {
      title: "Income",
      description: "Manage your income sources",
      icon: Coins, 
      color: "green",
      link: "/income/dashboard"
    },
    {
      title: "Expenses",
      description: "Control your spending",
      icon: CreditCard,
      color: "red", 
      link: "/expenses/dashboard"
    },
    {
      title: "Cashflow", 
      description: "Track your money movement",
      icon: TrendingUp,
      color: "blue",
      link: "/cashflow"
    },
    {
      title: "Investments",
      description: "Monitor your investments",
      icon: TrendingUp,
      color: "green",
      link: "/investments/dashboard"
    },
    {
      title: "Goals",
      description: "Set and track financial goals",
      icon: Target,
      color: "red",
      link: "/goals" 
    }
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col relative">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <TopBar 
          title="Welcome to Your Financial Analyst"
          subtitle="Your helper to your goals and financial success"
        />
        <main className="flex-grow flex items-center justify-center px-4 py-12">
          <div className="max-w-7xl w-full">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {items.map((item, index) => (
                <motion.div
                  key={item.title}
                  variants={cardVariants}
                  initial="hidden"
                  animate="visible"
                  transition={{ delay: index * 0.1 }}
                >
                  <Card className="bg-black border-gray-800 hover:bg-gray-900 transition-colors duration-300 h-[220px] flex flex-col shadow-xl">
                    <Link to={item.link} className="flex flex-col h-full">
                      <CardHeader className="flex-grow">
                        <CardTitle className={`flex items-center text-2xl font-bold text-${item.color}-600`}>
                          <item.icon className={`w-8 h-8 mr-3 text-${item.color}-600`} />
                          {item.title}
                        </CardTitle>
                        <CardDescription className="text-gray-300 text-lg mt-3">
                          {item.description}
                        </CardDescription>
                      </CardHeader>
                      <CardFooter className="mt-auto">
                        <Button 
                          className={`w-full bg-${item.color}-600 text-white hover:bg-${item.color}-500 border-${item.color}-700 hover:border-${item.color}-600 transition-colors duration-300`}
                        >
                          Explore {item.title}
                        </Button>
                      </CardFooter>
                    </Link>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
